<template>
  <div class="l-container Tutor_channelsIndex">
    現在表示数 {{max}}
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">ID</template>
      <!-- <template v&#45;if="this.sortColumn === 'user_id'">登録者</template> -->
      <template v-if="this.sortColumn === 'tutor_id'">tutor_id</template>
      <template v-if="this.sortColumn === 'name'">名前</template>
      <template v-if="this.sortColumn === 'kana'">かな</template>
      <template v-if="this.sortColumn === 'pref'">都道府県</template>
      <template v-if="this.sortColumn === 'address'">地域</template>
      <template v-if="this.sortColumn === 'channel_id'">媒体名</template>
      <template v-if="this.sortColumn === 'medium_note'">備考</template>
      <template v-if="this.sortColumn === 'registration_date'">登録日</template>
      <template v-if="this.sortColumn === 'created_at'">作成日</template>
       : {{sortState}}
    </span>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <!-- class="m-btn--column" <btn @click.native="switchV('user')" v&#45;bind:class="{ 'active': user }">User</btn> -->
        <btn class="m-btn--column" @click.native="switchV('tutor_id')" v-bind:class="{ 'active': tutor_id }">tutor_id</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('kana')" v-bind:class="{ 'active': kana }">かな</btn>
        <btn class="m-btn--column" @click.native="switchV('pref')" v-bind:class="{ 'active': pref }">都道府県</btn>
        <btn class="m-btn--column" @click.native="switchV('address')" v-bind:class="{ 'active': address }">地域</btn>
        <btn class="m-btn--column" @click.native="switchV('channel_id')" v-bind:class="{ 'active': channel_id }">媒体名</btn>
        <btn class="m-btn--column" @click.native="switchV('medium_note')" v-bind:class="{ 'active': medium_note }">備考</btn>
        <btn class="m-btn--column" @click.native="switchV('registration_date')" v-bind:class="{ 'active': registration_date }">登録日</btn>
        <btn class="m-btn--column" @click.native="switchV('registration_date')" v-bind:class="{ 'active': registration_date }">~ 登録日</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()"></td-c></template>
          <!-- <template v&#45;if="user"><td&#45;c><input v&#45;model="search.user" type="text" @keyup="searchTable()"></td&#45;c></template> -->
          <template v-if="tutor_id"><td-c><input v-model="search.tutor_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="pref">
            <td-c class="select">
              <multiselect v-model="watchSearch.pref" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="prefs" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="address"><td-c><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="channel_id">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.channel_id" :options="mapOffice_channels" label="mapChannel_id" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="medium_note"><td-c><input v-model="search.medium_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="registration_date"><td-c><input v-model="search.registration_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="registration_date"><td-c><input v-model="search.registration_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()"></td-c></template>
          <!-- <template v&#45;if="user"><td&#45;c><input v&#45;model="search.not_user" type="text" @keyup="searchTable()"></td&#45;c></template> -->
          <template v-if="tutor_id"><td-c><input v-model="search.not_tutor_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="pref">
            <td-c class="select">
              <multiselect v-model="watchSearch.not_pref" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="prefs" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="address"><td-c><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="channel_id">
            <td-c class="select">
              <multiselect @select="searchTable()" v-model="watchSearch.not_channel_id" :options="mapOffice_channels" label="mapChannel_id" :show-labels="false" placeholder=""></multiselect>
            </td-c>
          </template>
          <template v-if="medium_note"><td-c><input v-model="search.not_medium_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="registration_date"><td-c><input v-model="search.not_registration_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="registration_date"><td-c><input v-model="search.not_registration_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <!-- <template v&#45;if="user"><th&#45;c @click.native='sort("user")'>User</th&#45;c></template> -->
          <template v-if="tutor_id"><th-c @click.native='sort("tutor_id")'>tutor_id</th-c></template>
          <template v-if="name"><th-c @click.native='sort("name")'>名前</th-c></template>
          <template v-if="kana"><th-c @click.native='sort("kana")'>かな</th-c></template>
          <template v-if="pref"><th-c @click.native='sort("pref")'>都道府県</th-c></template>
          <template v-if="address"><th-c @click.native='sort("address")'>地域</th-c></template>
          <template v-if="channel_id"><th-c @click.native='sort("channel_id")'>媒体名</th-c></template>
          <template v-if="medium_note"><th-c @click.native='sort("medium_note")'>備考</th-c></template>
          <template v-if="registration_date"><th-c @click.native='sort("registration_date")'>登録日</th-c></template>
          <template v-if="registration_date"><th-c @click.native='sort("registration_date")'>~ 登録日</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in mapTutor_channels" :key="list.id">
          <template v-if="list.tutor">
            <template v-if="list.id == edit_id.edit_id">
              <td-c @click.native="cancelTutor_channel(list)" class="del" style="position: relative">戻る</td-c>
              <td-c @click.native="patchTutor_channel(list)" class="del" style="position: relative">更新</td-c>
              <template v-if="id"><td-c>{{list.id}}</td-c></template>
              <!-- <template v&#45;if="user"><td&#45;c>{{list.user.user}}</td&#45;c></template> -->
              <template v-if="tutor_id"><td-c><input type="text" v-model="list.tutor_id" style="font-weight: bold"></td-c></template>
              <template v-if="name"><td-c>{{list.tutor.f_name}} {{list.tutor.l_name}}</td-c></template>
              <template v-if="kana"><td-c>{{list.tutor.f_name_kana}} {{list.tutor.l_name_kana}}</td-c></template>
              <template v-if="pref"><td-c>{{list.tutor.mapPref}}</td-c></template>
              <template v-if="address"><td-c>{{list.tutor.address1}}{{list.tutor.address2}}</td-c></template>
              <template v-if="channel_id">
                <td-c class="select">
                  <multiselect v-model="watch.channel_id" :options="mapOffice_channels" label="mapChannel_id" :show-labels="false" placeholder=""></multiselect>
                </td-c>
              </template>
              <template v-if="medium_note"><td-c>{{list.tutor.medium_note}}</td-c></template>
              <template v-if="registration_date"><td-c><input type="text" v-model="list.registration_date" style="font-weight: bold"></td-c></template>
              <template v-if="registration_date"><td-c></td-c></template>
              <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
            </template>

            <template v-if="list.id !== edit_id.edit_id">
              <td-c @click.native="deleteTutor_channel(list)" class="del" style="position: relative">削除</td-c>
              <td-c @click.native="editTutor_channel(list)" class="del" style="position: relative">編集</td-c>
              <template v-if="id"><td-c>{{list.id}}</td-c></template>
              <template v-if="tutor_id"><td-c>{{list.tutor_id}}</td-c></template>
              <template v-if="name"><td-c>{{list.tutor.f_name}} {{list.tutor.l_name}}</td-c></template>
              <template v-if="kana"><td-c>{{list.tutor.f_name_kana}} {{list.tutor.l_name_kana}}</td-c></template>
              <template v-if="pref"><td-c>{{list.tutor.mapPref}}</td-c></template>
              <template v-if="address"><td-c>{{list.tutor.address1}}{{list.tutor.address2}}</td-c></template>
              <template v-if="channel_id"><td-c>{{list.channel.name}}</td-c></template>
              <template v-if="medium_note"><td-c>{{list.tutor.medium_note}}</td-c></template>
              <template v-if="registration_date"><td-c>{{list.registration_date}}</td-c></template>
              <template v-if="registration_date"><td-c></td-c></template>
              <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
            </template>
          </template>
          <template v-else>
            <td-c></td-c>
          </template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/tutor_channels/search?limit=' + config.LIMIT

// var TIMER = null // 入力されるのを待つ
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'tutor_channel',
  pageNames: 'tutor_channels'
}

let _ = window._
export default {
  computed: {
    obj () {
      return obj
    },

    user () {
      return this.$store.getters.user
    },

    max () {
      return this.$store.getters.max
    },

    tutor_channels () {
      return this.$store.getters.tutor_channels
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    channels () {
      return this.$store.getters.channels
    },

    office_channels () {
      return this.$store.getters.office_channels
    },

    orderedOffice_channels () {
      return _.orderBy(this.office_channels, 'id')
    },

    filteredOffice_channels () {
      let self = this
      return self.orderedOffice_channels.filter(office_channel => {
        return office_channel.state === 1 && office_channel.office_id === self.user.office_id
      })
    },

    mapOffice_channels () {
      return this.filteredOffice_channels.map(office_channel => {
        office_channel.mapChannel_id = this.calcArry(office_channel.channel_id, 'channels')
        return office_channel
      })
    },

    // order By
    orderedTutor_channels () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.tutor_channels, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.tutor_channels, this.sortColumn)
      }
    },

    mapTutor_channels () {
      return this.orderedTutor_channels.map(tutor_channel => {
        tutor_channel.tutor.mapPref = this.calcPref(tutor_channel.tutor.pref)
        return tutor_channel
      })
    }
  },
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      id: false,
      // user: false,
      tutor_id: false,
      name: false,
      kana: false,
      pref: true,
      address: true,
      channel_id: true,
      medium_note: false,
      registration_date: true,
      created_at: false,

      // search
      search: {
        id: '',
        // user: '',
        tutor_id: '',
        name: '',
        kana: '',
        pref: '',
        address: '',
        channel_id: '',
        medium_note: '',
        registration_date: [],
        created_at: '',

        not_id: '',
        // not_user: '',
        not_tutor_id: '',
        not_name: '',
        not_kana: '',
        not_pref: '',
        not_address: '',
        not_channel_id: '',
        not_medium_note: '',
        not_registration_date: [],
        not_created_at: ''
      },

      watchSearch: {
        channel_id: '',
        pref: [],

        not_channel_id: '',
        not_pref: []
      },

      // patch
      tutor_channel: {
        tutor_id: '',
        channel_id: '',
        registration_date: ''
      },

      watch: {
        channel_id: ''
      }
    }
  },
  watch: {
    'watch.channel_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.tutor_channel.channel_id = now.channel_id
      } else {
        this.tutor_channel.channel_id = ''
      }
    },

    'watchSearch.channel_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.channel_id = now.channel_id
      } else {
        this.search.channel_id = ''
      }
    },

    'watchSearch.not_channel_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.not_channel_id = now.channel_id
      } else {
        this.search.not_channel_id = ''
      }
    },

    'watchSearch.pref': function (now, old) {
      if (now) {
        this.search.pref = ''
        for (let i = 0; i < now.length; i++) {
          this.search.pref += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watchSearch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_pref += now[i].id + ' '
        }
        this.searchTable()
      }
    }
  },
  methods: {
    calcArry (val, text) {
      // console.log(this[text])
      if (this[text].length > 0) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcPref (val) {
      if (val) {
        return this.prefs.filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      // this.user = false
      this.tutor_id = false
      this.name = false
      this.kana = false
      this.pref = false
      this.address = false
      this.channel_id = false
      this.medium_note = false
      this.registration_date = false
      this.created_at = false
    },

    all () {
      this.id = true
      // this.user = true
      this.tutor_id = true
      this.name = true
      this.kana = true
      this.pref = true
      this.address = true
      this.channel_id = true
      this.medium_note = true
      this.registration_date = true
      this.created_at = true
    },

    def () {
      this.id = false
      // this.user = false
      this.tutor_id = false
      this.name = false
      this.kana = false
      this.pref = true
      this.address = true
      this.channel_id = true
      this.medium_note = false
      this.registration_date = true
      this.created_at = false
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      // this.search.user = ''
      this.search.tutor_id = ''
      this.search.name = ''
      this.search.kana = ''
      this.watchSearch.pref = []
      this.search.address = ''
      this.watchSearch.channel_id = 0
      this.search.medium_note = ''
      this.search.registration_date = []
      this.search.created_at = ''

      this.search.not_tutor_id = ''
      this.search.name = ''
      this.search.kana = ''
      this.watchSearch.not_pref = []
      this.search.not_address = ''
      this.watchSearch.not_channel_id = 0
      this.search.not_medium_note = ''
      this.search.not_registration_date = []
      this.search.not_created_at = ''

      this.searchTable()
    },

    editTutor_channel (list) {
      this.edit_id.edit_id = list.id

      console.log(list.channel.name)
      console.log(list.channel_id)
      let a = list.channel.name
      let b = list.channel_id
      let obj = {}
      obj.mapChannel_id = a
      obj.channel_id = b
      console.log(obj)
      this.watch.channel_id = obj
    },

    deleteTutor_channel (list) {
      this.$store.dispatch('deleteTutor_channel', {
        this: this,
        list: list
      })
    },

    cancelTutor_channel (list) {
      this.$store.dispatch('cancelTutor_channel', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchTutor_channel (list) {
      this.$store.dispatch('patchTutor_channel', {
        this: this,
        list: list,
        tutor_channel: this.tutor_channel,
        edit_id: this.edit_id
      })
      this.searchTable()
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
  font-size: 12px;
}
.index-box {
  height: calc(100vh - 210px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  width: 80px;
  &:hover {
    background: black;
    color: white;
  }
}
</style>
<style lang="scss">
.Tutor_channelsIndex {
  .select {
    padding: 0 !important;
  }
  .multiselect {
    min-height: 23px;
    min-width: 110px;
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 3px 1px 1px 1px;
  }
  .multiselect__tags-wrap {
    /* background: red; */
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// Tutor_channelsIndex.vue?5819e8fa